import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Clientes from './views/Clientes.vue'
import Vendedor from './views/Vendedor.vue'
import Planes from './views/Planes.vue'
import Cobrador from './views/Cobrador.vue'
import Login from './views/Login.vue'
import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/planes',
      name: 'planes',
      component: Planes
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: Clientes
    },
    {
      path: '/vendedores',
      name: 'vendedores',
      component: Vendedor
    },
    {
      path: '/cobradores',
      name: 'cobradores',
      component: Cobrador
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(!firebase.auth().currentUser && !['/login', '/about'].includes(to.path) ) {
    next('/login')
  } else {
    next()
  }
})

export default router
